 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"activity-add-activity-add-module":"activity-add-activity-add-module","analytics-analytics-module":"analytics-analytics-module","attachment-attachment-module":"attachment-attachment-module","canvg":"canvg","change-url-change-url-module":"change-url-change-url-module","choose-number-choose-number-module":"choose-number-choose-number-module","choose-owner-choose-owner-module":"choose-owner-choose-owner-module","command-to-many-trackers-command-to-many-trackers-module":"command-to-many-trackers-command-to-many-trackers-module","comment-zendesk-comment-zendesk-module":"comment-zendesk-comment-zendesk-module","common":"common","aggiungi-landing-aggiungi-landing-module":"aggiungi-landing-aggiungi-landing-module","aggiungi-sconti-aggiungi-sconti-module":"aggiungi-sconti-aggiungi-sconti-module","batch-migration-batch-migration-module":"batch-migration-batch-migration-module","codici-sconto-amazon-codici-sconto-amazon-module":"codici-sconto-amazon-codici-sconto-amazon-module","edit-referral-edit-referral-module":"edit-referral-edit-referral-module","inserimento-magazzino-fota-inserimento-magazzino-fota-module":"inserimento-magazzino-fota-inserimento-magazzino-fota-module","inserimento-magazzino-inserimento-magazzino-module":"inserimento-magazzino-inserimento-magazzino-module","insert-tracker-insert-tracker-module":"insert-tracker-insert-tracker-module","landing-pages-landing-pages-module":"landing-pages-landing-pages-module","migration-migration-module":"migration-migration-module","modify-position-modify-position-module":"modify-position-modify-position-module","organization-detail-organization-detail-module":"organization-detail-organization-detail-module","referral-referral-module":"referral-referral-module","send-sms-send-sms-module":"send-sms-send-sms-module","start-migration-start-migration-module":"start-migration-start-migration-module","test-route-alarm-test-route-alarm-module":"test-route-alarm-test-route-alarm-module","trackers-trackers-module":"trackers-trackers-module","companies-companies-module":"companies-companies-module","company-add-company-add-module":"company-add-company-add-module","company-edit-company-edit-module":"company-edit-company-edit-module","contact-add-contact-add-module":"contact-add-contact-add-module","contact-edit-contact-edit-module":"contact-edit-contact-edit-module","contacts-contacts-module":"contacts-contacts-module","contatti-landing-contatti-landing-module":"contatti-landing-contatti-landing-module","create-message-create-message-module":"create-message-create-message-module","default~activities-to-do-activities-to-do-module~adv-adv-module~marketing-marketing-module~reviews-r~9c733241":"default~activities-to-do-activities-to-do-module~adv-adv-module~marketing-marketing-module~reviews-r~9c733241","adv-adv-module":"adv-adv-module","marketing-marketing-module":"marketing-marketing-module","reviews-reviews-module":"reviews-reviews-module","sms-sms-module":"sms-sms-module","default~chat-chat-module~edit-balance-edit-balance-module~organizations-organizations-module":"default~chat-chat-module~edit-balance-edit-balance-module~organizations-organizations-module","chat-chat-module":"chat-chat-module","organizations-organizations-module":"organizations-organizations-module","edit-balance-edit-balance-module":"edit-balance-edit-balance-module","default~check-payments-check-payments-module~payment-actions-payment-actions-module~supporto-tecnico~e07047a2":"default~check-payments-check-payments-module~payment-actions-payment-actions-module~supporto-tecnico~e07047a2","check-payments-check-payments-module":"check-payments-check-payments-module","payment-actions-payment-actions-module":"payment-actions-payment-actions-module","supporto-tecnico-supporto-tecnico-module":"supporto-tecnico-supporto-tecnico-module","default~command-to-sim-command-to-sim-module~controllo-trackers-controllo-trackers-module":"default~command-to-sim-command-to-sim-module~controllo-trackers-controllo-trackers-module","command-to-sim-command-to-sim-module":"command-to-sim-command-to-sim-module","controllo-trackers-controllo-trackers-module":"controllo-trackers-controllo-trackers-module","detail-detail-module":"detail-detail-module","dompurify":"dompurify","fake-positions-fake-positions-module":"fake-positions-fake-positions-module","formatta-formatta-module":"formatta-formatta-module","get-tracker-by-email-get-tracker-by-email-module":"get-tracker-by-email-get-tracker-by-email-module","home-home-module":"home-home-module","html2canvas":"html2canvas","login-login-module":"login-login-module","mingrazioni-sofware-errore-mingrazioni-sofware-errore-module":"mingrazioni-sofware-errore-mingrazioni-sofware-errore-module","modify-ticket-modify-ticket-module":"modify-ticket-modify-ticket-module","new-call-new-call-module":"new-call-new-call-module","new-contact-new-contact-module":"new-contact-new-contact-module","new-ticket-new-ticket-module":"new-ticket-new-ticket-module","orders-archivied-orders-archivied-module":"orders-archivied-orders-archivied-module","orders-orders-module":"orders-orders-module","phonebook-activities-phonebook-activities-module":"phonebook-activities-phonebook-activities-module","phonebook-phonebook-module":"phonebook-phonebook-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","reinvio-programmazione-reinvio-programmazione-module":"reinvio-programmazione-reinvio-programmazione-module","send-command-send-command-module":"send-command-send-command-module","send-dispute-send-dispute-module":"send-dispute-send-dispute-module","send-email-send-email-module":"send-email-send-email-module","shadow-css-fc98efba-js":"shadow-css-fc98efba-js","sms-to-phone-sms-to-phone-module":"sms-to-phone-sms-to-phone-module","sostituisci-sostituisci-module":"sostituisci-sostituisci-module","stock-amazon-stock-amazon-module":"stock-amazon-stock-amazon-module","stock-witek-stock-witek-module":"stock-witek-stock-witek-module","test-alarm-notification-test-alarm-notification-module":"test-alarm-notification-test-alarm-notification-module","tracker-replace-tracker-replace-module":"tracker-replace-tracker-replace-module","tracker-tracker-module":"tracker-tracker-module","swiper-bundle-95afeea2-js":"swiper-bundle-95afeea2-js","focus-visible-15ada7f7-js":"focus-visible-15ada7f7-js","input-shims-b956f530-js":"input-shims-b956f530-js","keyboard-dd970efc-js":"keyboard-dd970efc-js","status-tap-a9bf301d-js":"status-tap-a9bf301d-js","swipe-back-0a6a44c8-js":"swipe-back-0a6a44c8-js","tap-click-252af35a-js":"tap-click-252af35a-js","calls-calls-module":"calls-calls-module","activities-to-do-activities-to-do-module":"activities-to-do-activities-to-do-module","tickets-tickets-module":"tickets-tickets-module","whatsapp-whatsapp-module":"whatsapp-whatsapp-module","rubrica-rubrica-module":"rubrica-rubrica-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
